export const CATEGORIES = ["Tutti", "Corpo", "Capelli", "Igiene intima", "Incontinenza"];

export const PRODUCT_MEDIA = {
  "bagno-doccia-lenitivo": { name: "Bagno Doccia Lenitivo", image: "/images/products/bagno-doccia-v2.jpg", focus: "22% 60%" },
  "detergente-mani-delicato": { name: "Detergente Mani Delicato", image: "/images/products/detergente-mani-v2.jpg", focus: "22% 60%" },
  "crema-corpo-nutriente": { name: "Crema Corpo Nutriente", image: "/images/products/crema-corpo-v2.jpg", focus: "25% 60%" },
  "balsamo-corpo-riparatore": { name: "Balsamo Corpo Riparatore", image: "/images/products/balsamo-corpo-v2.jpg", focus: "28% 60%" },
  "shampoo-delicato": { name: "Shampoo Delicato", image: "/images/products/shampoo-v2.jpg", focus: "28% 60%" },
  "trattamento-cuoio-capelluto": { name: "Trattamento Cuoio Capelluto", image: "/images/products/cuoio-capelluto-v2.jpg", focus: "25% 60%" },
  "detergente-intimo-delicato": { name: "Detergente Intimo Delicato", image: "/images/products/intimo-v2.jpg", focus: "28% 60%" },
  "deo-active": { name: "Deo Active", image: "/images/products/deo-v2.jpg", focus: "35% 60%" },
  "salviette-detergenti": { name: "Salviette Detergenti", image: "/images/products/salviette-v2.jpg", focus: "30% 60%" },
  "pannoloni-adulti-a-strappo": { name: "Pannoloni per Adulti", image: "/images/products/pannoloni-v2.jpg", focus: "40% 60%" },
};

export const CHAPTERS = [
  {
    n: "I",
    eyebrow: "La pelle che ha vissuto",
    title: "Con gli anni la pelle cambia. La cura deve cambiare con lei.",
    text: "L'epidermide si assottiglia, trattiene meno acqua e la sua barriera naturale diventa più fragile. I detergenti comuni, pensati per pelli giovani, rischiano di impoverirla ancora di più. Perfero nasce da qui: formule delicate, dedicate alla pelle matura.",
    image: "/images/scene-hands.jpg",
    alt: "Mani di una persona anziana accanto ai prodotti Perfero",
    position: "6% 70%",
  },
  {
    n: "II",
    eyebrow: "Il 2-nonenale",
    title: "Una molecola di cui nessuno parla. Noi sì.",
    text: "Con l'avanzare dell'età la pelle produce il 2-nonenale, responsabile di un odore caratteristico che acqua e sapone comune faticano a rimuovere. Molte formule Perfero sono attive contro il 2-nonenale: una freschezza autentica, non coperta.",
    image: "/images/products/deo-v2.jpg",
    alt: "Perfero Deo Active, attivo contro il 2-nonenale",
    position: "50% 30%",
  },
  {
    n: "III",
    eyebrow: "Il segreto dell'elicriso",
    title: "Un fiore d'oro del Mediterraneo, trasformato in cura.",
    text: "L'elicriso è da sempre apprezzato per le sue virtù lenitive. Perfero ne porta i postbiotici al centro delle sue formule, per una cura che rispetta l'equilibrio naturale della pelle.",
    image: "/images/elicriso.jpg",
    alt: "Fiori dorati di elicriso alla luce del sole",
    position: "50% 35%",
  },
  {
    n: "IV",
    eyebrow: "Dignità, ogni giorno",
    title: "Per chi si cura e per chi si prende cura.",
    text: "Flaconi con dosatore, formati pratici e una linea completa: dalla detersione al trattamento, fino all'igiene intima e all'incontinenza. Perché la cura quotidiana resti un gesto semplice, sereno e pieno di rispetto.",
    image: "/images/scene-care.jpg",
    alt: "Una donna si prende cura di una signora anziana sorridente",
    position: "72% 30%",
  },
];

export const RITUAL = [
  {
    n: "I",
    time: "Il risveglio",
    title: "Un inizio dolce",
    text: "Il primo gesto del giorno è un piccolo piacere: una detersione delicata che rispetta la pelle e i capelli, senza impoverirli.",
    products: ["bagno-doccia-lenitivo", "shampoo-delicato", "trattamento-cuoio-capelluto"],
  },
  {
    n: "II",
    time: "Durante il giorno",
    title: "Freschezza che accompagna",
    text: "Mani lavate spesso e sempre morbide, una freschezza di lunga durata: per sentirsi a proprio agio in ogni incontro.",
    products: ["detergente-mani-delicato", "deo-active"],
  },
  {
    n: "III",
    time: "In ogni momento",
    title: "Igiene semplice e sicura",
    text: "A casa o fuori, in autonomia o con l'aiuto di chi assiste: gesti di igiene intima delicati e pratici.",
    products: ["detergente-intimo-delicato", "salviette-detergenti"],
  },
  {
    n: "IV",
    time: "La sera",
    title: "Nutrire e riparare",
    text: "Quando la giornata finisce, la pelle chiede nutrimento: una crema che rinforza la barriera e un balsamo che lenisce e rigenera.",
    products: ["crema-corpo-nutriente", "balsamo-corpo-riparatore"],
  },
  {
    n: "V",
    time: "La notte",
    title: "Un riposo sereno",
    text: "Massima assorbenza, pelle asciutta e massimo comfort, per riposare tranquilli e risvegliarsi con dignità.",
    products: ["pannoloni-adulti-a-strappo"],
  },
];
